import { render, staticRenderFns } from "./yiShoujinE.vue?vue&type=template&id=6709414a&scoped=true&"
import script from "./yiShoujinE.vue?vue&type=script&lang=js&"
export * from "./yiShoujinE.vue?vue&type=script&lang=js&"
import style0 from "./yiShoujinE.vue?vue&type=style&index=0&id=6709414a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6709414a",
  null
  
)

export default component.exports